import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  titulo: {
    fontSize: 16,
    marginLeft: 20,
    color: '#5e6784',
    fontWeight: 'bold'
  },
  subtitulo: {
    marginLeft: '16px',
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#5e6784',
  },
  paper: {
    maxWidth: 484,
    width: 'calc(100vw - 44px)',
    position: 'absolute',
    right: 44,
    paddingBottom: 70,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
    padding: 20
  },
}));

export default useStyles;
